export default __webpack_public_path__ + "static/media/otherdays.ff2ae0d1.svg";